<!-- <mat-spinner *ngIf="loading" diameter="50"></mat-spinner> -->
<div *ngIf="loading" class="overlay">
    <!-- Using the color property to set the spinner's color to yellow -->
    <mat-spinner class="orange-spinner" diameter="100"></mat-spinner>
  </div>
